import { NgClass } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { Countries } from 'app/modules/shared/countries';
import { OnlyDigitsDirective } from 'app/modules/shared/directives/only-digits.directives';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { CalendarModule } from 'primeng/calendar';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { Country } from 'app/modules/shared/models/country';

@Component({
  selector: 'app-mobile-input',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CalendarModule, InputGroupModule, InputGroupAddonModule, DropdownModule, KeyFilterModule, InputTextModule, TranslateModule, NgClass, OnlyDigitsDirective],
  templateUrl: './mobile-input.component.html',
  styleUrls: ['./mobile-input.component.scss', './flags.scss']
})
export class MobileInputComponent implements OnInit {
  @ViewChild('dropdown') dropdown!: Dropdown;
  @Input() field: any;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  formName: FormGroup;
  placeholder: any;
  countries: any[] | undefined;
  country: Country;
  selectedCountry: any;
  selectedMobile: any;
  filterIcon = 'pi pi-search';
  showMobileValidationError: boolean = false;
  timeZoneCode;
  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private metaDataService: MetaDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit(): void {
    this.timeZoneCode = '';
    this.setCountryCode();
    this.setMobileInEditMode();
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
  }

  setMobileInEditMode() {
    const mobileNumberWithCountryCode = this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].value;
    if (mobileNumberWithCountryCode) {
      const mobileNumberCountryCodeArray = mobileNumberWithCountryCode.split('-');
      this.selectedMobile = mobileNumberCountryCodeArray[1];
      this.selectedCountry = Countries.COUNTRY_CODE.find(ele => ele.value === mobileNumberCountryCodeArray[0]);
    } else {
      this.selectedCountry = this.countries.find(country => country.value === AppSettings.DEFAULT_COUNTRY_CODE);
    }
  }

  setCountryCode() {
    this.countries = Countries.COUNTRY_CODE;
    const filteredCountries = this.countries.filter(country => country.timezone === this.timeZoneCode);
    this.selectedCountry = filteredCountries[0];
  }

  validatePhoneNumber(countryCode: string, phoneNumber: string): boolean {
    try {
      const formattedCountryCode = countryCode.startsWith('+') ? countryCode : `+${countryCode}`;
      return isValidPhoneNumber(`${formattedCountryCode}${phoneNumber}`);
    } catch (error) {
      return false;
    }
  }

  selectCountry(): void {
    const mobileNumber: any[] = [this.selectedCountry?.value, this.selectedMobile];
    this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue(mobileNumber.join('-'));
    this.formName.get(this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode).updateValueAndValidity();
    if (this.selectedMobile) {
      const isValid = this.validatePhoneNumber(this.selectedCountry?.value, this.selectedMobile);
      this.showMobileValidationError = !isValid;
    } else {
      this.showMobileValidationError = false;
    }
    const control = this.formName.get(this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode);
    if (control) {
      control.markAsTouched();
    }
  }

  onBlurMobile() {
    const control = this.formName.get(this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode);
    if (control) {
      control.markAsTouched();
    }
  }

  onFilter(event) {
    if (event.filter) {
      this.filterIcon = 'pi pi-times'
    } else {
      this.filterIcon = 'pi pi-search';
    }
  }

  onFilterIconClick() {
    if (this.filterIcon.includes('times')) {
      this.dropdown.filterValue = null;
      this.filterIcon = 'pi pi-search';
    }
  }
}
